import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import dotenv from "dotenv";
import AdminLayout from "layouts/admin";

export default function App() {
  dotenv.config();
  console.log(process.env.NODE_ENV)
  return (
      <Switch>
      <Route path={`/`} component={AdminLayout} />
      <Redirect from="/" to="/board" />
    </Switch>
  )
}
